module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selected-for-sale-property-cluster-pin-c937a34ba531b4ef40afd714d4928818.svg";